import React from 'react'
import { Modal } from 'react-bootstrap'
import CariDoctorService from '../Service/cariDoctorService'
import SpesialisSevice from '../Service/spesialisService'
import alamatRService from '../Service/alamatRService'
import TindakanMedis from '../Service/tinMedisService'
import { config } from '../Config/config'
import LamaPengalaman from '../Service/pengalamanDoctor'

export default class index extends React.Component {

    DoctorModel = {
        _id: "",
        biodata_id: "",
        doctor_id: "",
        specialization: "",
        medical_facility_id: "",
        str: "",
        name: "",
        fullname: "",
        mobile_phone: "",
        image: "",
        image_path: "",
        create_by: "",
        create_on: "",
        modified_by: "",
        modified_on: "",
        deleted_by: "",
        deleted_on: "",
        is_delete: false
    }

    constructor() {
        super()
        this.state = {
            List: [],
            ListSpesialis: [],
            ListAlamat: [],
            ListTindakanMedis: [],
            ListPengalaman:[],
            Model: this.DoctorModel,
            ShowModal: false,
            errors: {},
            filter: {
                location: '',
                spes: '',
                nameDoc: '',
                tinMed: '',
                page: '1',
                pagesize: '3',
            },
            pencarian: {}
        }
    }

    //fungsi untuk ngisi chekbox
    changeHandler = field => ({ target: { value } }) => {

        this.setState({
            Model: {
                ...this.state.Model,
                [field]: value
            }
        })
    }

    //untuk manggil semua data yang ada di db
    loadList = async () => {
        // const Filter = this.state.filter
        const respon = await CariDoctorService.getFilter(this.state.filter)
        const responSpesialis = await SpesialisSevice.getAll()
        const responAlamat = await alamatRService.getAllRS()
        const responTindakanMedis = await TindakanMedis.getAll()
        const responLamaPengalaman = await LamaPengalaman.getAllPengalaman()
        

        // var CariDokter = [{ Filter }]
        // localStorage.setItem(config.filter, JSON.stringify(CariDokter))
        // var filter2 = localStorage.getItem(config.filter)
        // console.log(localStorage.getItem(config.filter))
        // var filter2 = JSON.parse(localStorage.getItem(config.filter))
        // console.log(filter2)
        if (respon.success) {
            this.setState({
                List: respon.result,
                ListSpesialis: responSpesialis.result,
                ListAlamat: responAlamat.result,
                ListTindakanMedis: responTindakanMedis.result,
                ListPengalaman: responLamaPengalaman.result
            })
        }
    }

    searchList = () => {
        localStorage.setItem(config.filter, JSON.stringify(this.state.filter))

        if (this.handleValidation()) {
            localStorage.setItem(config.loc, this.state.filter.location)
            localStorage.setItem(config.spes, this.state.filter.spes)
            localStorage.setItem(config.nameDoc, this.state.filter.nameDoc)
            localStorage.setItem(config.tinMed, this.state.filter.tinMed)
            localStorage.setItem(config.page, this.state.filter.page)
            localStorage.setItem(config.pagesize, this.state.filter.pagesize)


            var hasilPencarian = []

            if (localStorage.getItem(config.loc).length > 0) {
                hasilPencarian.push("Location " + localStorage.getItem(config.loc))
            }

            if (localStorage.getItem(config.spes).length > 0) {
                hasilPencarian.push("Spesialis/Sub Spesialis " + localStorage.getItem(config.spes))
            }

            if (localStorage.getItem(config.nameDoc).length > 0) {
                hasilPencarian.push("Nama Dokter " + localStorage.getItem(config.nameDoc))
            }

            if (localStorage.getItem(config.tinMed).length > 0) {
                hasilPencarian.push("Tindakan Medis " + localStorage.getItem(config.tinMed))
            }


            this.setState({
                pencarian: hasilPencarian.join(",")

            }, () => localStorage.setItem(config.hasilCariDoctor, this.state.pencarian))


            window.location.href = "/formCariDoctor"
        }
    }

    //pertama kali ditampilkan akan muncul loadlist
    componentDidMount() {
        this.loadList()
    }


    cancelHandler = () => {
        this.setState({
            Mode: "",
            ShowModal: false
        })
    }

    filterHandler = field => ({ target: { value } }) => {
        //setState untuk mengupdate
        this.setState({
            filter: {
                ...this.state.filter,
                [field]: value
            }
        })
    }

    aturUlang = () => {
        document.getElementById("search-field").reset();
        this.setState({
            filter: {
                location: '',
                spes: '',
                nameDoc: '',
                tinMed: '',
                page: '1',
                pagesize: '3'
            }
        })
    }

    handleValidation = () => {
        let Fields = this.state.filter;
        let errors = {};
        let formIsValid = true;

        //Name
        if (!Fields["spes"]) {
            formIsValid = false;
            errors["spes"] = "Data Tidak Boleh Kosong";
        }

        this.setState({ errors: errors });
        return formIsValid;
    }

    faskesHandler = async () => {
        const responListTreat = await AppointmentService.getTreatmentByDoctorOfficeId(this.state.Model.doctor_office_id)
        if (responListTreat.success) {
            this.setState({
                listTreatment: responListTreat.result,
            })
        }
    }


    render() {
        const { Model, ListSpesialis, changeHandler, ListAlamat, ListTindakanMedis, filter, errors, ListPengalaman } = this.state
        const { showModalDoctor, cancelModal } = this.props
        return (

            <div class="mb-10">

                {/* <Modal show={true} onHide={handleClose}> */}
                <Modal show={showModalDoctor} onHide={cancelModal}>
                    {/* {JSON.stringify(this.state.cari)} */}
                    {/* {JSON.stringify(this.state.ListPengalaman)} */}
                    <Modal.Header closeButton>
                        <div class="row">
                            <div class="col-12">
                                <h4 class="page-title" style={{ color: "blue" }}>Cari Doctor</h4>
                            </div>

                            <div class="col-12">
                                <text class="page-title" style={{ fontSize: 15, color: "grey", fontStyle: "italic" }}>Masukan minimal 1 kata kunci untuk pencarian doctor Anda</text>
                            </div>
                        </div>
                    </Modal.Header>

                    <Modal.Body>
                        <form id="search-field">

                            <div class="row">

                                <div class="col-12">
                                    <label for="location" class="form-label">Lokasi</label>
                                    <select class="form-control" onChange={this.filterHandler("location")}>
                                        <option selected hidden></option>
                                        {ListAlamat.map(data => {
                                            return (
                                                <option>{data._id}</option>
                                            )
                                        })}
                                    </select>
                                </div>

                                <div class="col-12">
                                    <div class="card-tools">
                                        <div class="input-group input-group-sm">
                                            <text>Nama Dokter</text>
                                        </div>
                                        <div class="input-group input-group-sm">
                                            <input type="text" style={{ width: 400 }} name="table_search" class="form-control float-right" onChange={this.filterHandler("nameDoc")} />
                                        </div>
                                    </div>
                                </div>

                                <div class="col-12">
                                    <label for="spes" class="form-label">Spesialis/Sub-Spesialis*</label>
                                    <select class="form-control" onChange={this.filterHandler("spes")}>
                                        <option selected hidden>--Pilih--</option>
                                        {ListSpesialis.map(data => {
                                            return (
                                                <option>{data.name}</option>
                                            )
                                        })}
                                    </select>
                                    <span className="error" style={{ color: "red", fontStyle: "italic" }}>{errors["spes"]}</span>
                                </div>

                                <div class="col-12">
                                    <label for="tinMed" class="form-label">Tindakan Medis</label>
                                    <select class="form-control" onChange={this.filterHandler("tinMed")}>
                                        <option selected hidden></option>
                                        {ListTindakanMedis.map(data => {
                                            return (
                                                <option>{data.name}</option>
                                            )
                                        })}
                                    </select>
                                </div>

                            </div>
                        </form>
                    </Modal.Body>
                    <Modal.Footer>
                        <button type="submit" class="btn btn-primary" onClick={this.searchList}>Cari</button>
                        <button type="cancel" class="btn btn-dafault" onClick={this.aturUlang}>Atur Ulang</button>
                    </Modal.Footer>
                </Modal>

                {/* <TampilanSearch
                    TampilanSearch={this.loadList}
                /> */}
            </div>

        )
    }

}